import { render } from "./ProFormas.vue?vue&type=template&id=2931e6a6&scoped=true"
import script from "./ProFormas.vue?vue&type=script&lang=js"
export * from "./ProFormas.vue?vue&type=script&lang=js"

import "./ProFormas.vue?vue&type=style&index=0&id=2931e6a6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2931e6a6"]])

export default __exports__